var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilter({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 3.45C1.5 3.02996 1.5 2.81994 1.58175 2.65951C1.65365 2.51839 1.76839 2.40365 1.90951 2.33175C2.06994 2.25 2.27996 2.25 2.7 2.25H15.3C15.72 2.25 15.9301 2.25 16.0905 2.33175C16.2316 2.40365 16.3463 2.51839 16.4183 2.65951C16.5 2.81994 16.5 3.02996 16.5 3.45V3.95205C16.5 4.15364 16.5 4.25444 16.4754 4.34817C16.4535 4.43123 16.4176 4.50993 16.3691 4.58082C16.3144 4.66082 16.2383 4.72684 16.0859 4.85887L11.2891 9.01613C11.1367 9.14816 11.0606 9.21418 11.0059 9.29418C10.9574 9.36507 10.9215 9.44377 10.8996 9.52683C10.875 9.62056 10.875 9.72136 10.875 9.92295V13.8438C10.875 13.9905 10.875 14.0638 10.8513 14.1272C10.8304 14.1832 10.7964 14.2334 10.7522 14.2736C10.7021 14.3192 10.634 14.3464 10.4978 14.4009L7.94783 15.4209C7.67218 15.5311 7.53435 15.5863 7.4237 15.5633C7.32695 15.5432 7.24204 15.4857 7.18744 15.4033C7.125 15.3091 7.125 15.1607 7.125 14.8638V9.92295C7.125 9.72136 7.125 9.62056 7.10037 9.52683C7.07854 9.44377 7.0426 9.36507 6.99413 9.29418C6.93943 9.21418 6.86326 9.14816 6.71092 9.01613L1.91408 4.85887C1.76174 4.72684 1.68557 4.66082 1.63087 4.58082C1.5824 4.50993 1.54646 4.43123 1.52463 4.34817C1.5 4.25444 1.5 4.15364 1.5 3.95205V3.45Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.fa0a4b248148bf011b8c6d57be9c077e.svg";
export { ForwardRef as ReactComponent };